'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toCISImpression = exports.iterateOverContactMatches = exports.setTemplateClasses = exports.templateRenderer = exports.templateReducer = exports.templateReplacer = exports.formatContact = exports.protocolByContactType = undefined;

var _iterateOverContactMatches = require('./iterate-over-contact-matches');

Object.defineProperty(exports, 'iterateOverContactMatches', {
  enumerable: true,
  get: function get() {
    return _iterateOverContactMatches.iterateOverContactMatches;
  }
});

var _toCisImpression = require('./to-cis-impression');

Object.defineProperty(exports, 'toCISImpression', {
  enumerable: true,
  get: function get() {
    return _toCisImpression.toCISImpression;
  }
});

var _replace = require('lodash/replace');

var _replace2 = _interopRequireDefault(_replace);

var _escapeRegExp = require('lodash/escapeRegExp');

var _escapeRegExp2 = _interopRequireDefault(_escapeRegExp);

var _compact = require('lodash/compact');

var _compact2 = _interopRequireDefault(_compact);

var _join = require('lodash/join');

var _join2 = _interopRequireDefault(_join);

var _setTemplateClasses = require('./set-template-classes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PLACEHOLDER_DELIMITTER = '__CIS__';

var getPlaceholder = function getPlaceholder(i) {
  return '' + PLACEHOLDER_DELIMITTER + i + PLACEHOLDER_DELIMITTER;
};

var protocolByContactType = exports.protocolByContactType = {
  Phone: 'tel',
  Email: 'mailto',
  Web: 'http'
};

var getClassAttributeValue = function getClassAttributeValue(type) {
  return _setTemplateClasses.templateClasses[type] || '';
};
var getSharedAttributes = function getSharedAttributes(_ref) {
  var type = _ref.type,
      value = _ref.value;
  return 'data-contact-match="true" href="' + protocolByContactType[type] + ':' + value + '"';
};

var formatContact = exports.formatContact = function formatContact(regexMatch, _ref2) {
  var type = _ref2.type,
      value = _ref2.value;

  var sharedAttributes = getSharedAttributes({ type: type, value: value });

  var classAttributeValue = getClassAttributeValue(type);
  var classAttributeString = classAttributeValue && 'class="' + classAttributeValue + '"';

  var wrapperAttributes = (0, _join2.default)((0, _compact2.default)([classAttributeString, sharedAttributes]), ' ');

  return '<a ' + wrapperAttributes + '>' + regexMatch + '</a>';
};

var templateReplacer = exports.templateReplacer = function templateReplacer(template, contactMatch, customFormatter) {
  var contact = (0, _escapeRegExp2.default)(contactMatch.value);

  var formatter = function formatter(regexMatch) {
    var tagsRegex = new RegExp('^<', 'i');

    if (tagsRegex.test(regexMatch)) {
      return regexMatch;
    }

    return customFormatter ? customFormatter() : formatContact(regexMatch, contactMatch);
  };

  return (0, _replace2.default)(template, new RegExp('<img .*' + contact + '.*" />|' + contact, 'gi'), formatter);
};

var templateReducer = exports.templateReducer = function templateReducer(template, contactMatches) {
  var templateWithPlaceholders = contactMatches.reduce(function (out, contactMatch, i) {
    return templateReplacer(out, contactMatch, function () {
      return getPlaceholder(i);
    });
  }, template);

  return contactMatches.reduce(function (out, contactMatch, i) {
    return (0, _replace2.default)(out, new RegExp(getPlaceholder(i), 'gi'), formatContact(contactMatch.value, contactMatch));
  }, templateWithPlaceholders);
};

var templateRenderer = function templateRenderer() {
  return function () {
    var template = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var contactMatches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return templateReducer(template, contactMatches);
  };
};

// Public exports
exports.templateRenderer = templateRenderer;
exports.setTemplateClasses = _setTemplateClasses.setTemplateClasses;